import departments from 'utils/constants/department.json'
import sections from 'utils/constants/section.json'
import family from 'utils/constants/family.json'

export const noneField = {
  label: '--- NONE ---',
  value: 'NONE',
  disabled: false,
}

/**
 * Get Family by family code
 */
const getFamily = (familyCode: string) => {
  return family.find((fm) => fm.familyCode === familyCode)?.family ?? '-'
}

/**
 * Get Section by Section code
 */
const getSection = (sectionCode: string) => {
  return (
    sections.find((section) => section.sectionCode === sectionCode)?.section ??
    '-'
  )
}

/**
 * Get Department by Department code
 */
const getDepartment = (deptCode: string) => {
  return (
    departments.find((dept) => dept.departmentCode === deptCode)?.department ??
    '-'
  )
}

const getDepartmentOptions = () => {
  const options = departments.map((dept) => ({
    value: dept.departmentCode,
    label: dept.department,
    disabled: false,
  }))

  options.unshift(noneField)
  return options
}

const getSectionOptionsByDepartment = (dept: string) => {
  if (dept === 'NONE') {
    return [noneField]
  }

  const options = sections
    .filter((section) => dept === section.departmentCode)
    .map((section) => ({
      value: section.sectionCode,
      label: section.section,
      disabled: false,
    }))

  options.unshift(noneField)

  return options
}

const getFamiliesOptionsBySection = (section: string) => {
  if (!section || section === 'NONE') {
    return [noneField]
  }

  const options = family
    .filter((fm) => fm.sectionCode === section)
    .map((fm) => ({
      value: fm.familyCode,
      label: fm.family,
      disabled: false,
    }))

  options.unshift(noneField)

  return options
}

export {
  getDepartment,
  getDepartmentOptions,
  getFamily,
  getFamiliesOptionsBySection,
  getSection,
  getSectionOptionsByDepartment,
}
